module.exports = __webpack_public_path__ + "img/user-small.43328538.png";